import React from 'react';
import Main from '../../Components/404/Main/Main';

export default (): React.ReactElement => (
  <Main />
);
